module.exports = __webpack_public_path__ + "media/bootstrap-icons/bicycle-60df049e.svg";